import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("divider__hr-3lbafm", {
  opacity: 0.6,
  borderColor: "var(--system-grey-200)",
  borderStyle: "solid",
  borderTopWidth: "1px",
  width: "100%"
});
import React from 'react';
import { colors } from '../colors';
const Divider = ({
  className,
  ...props
}: HtmlPropsNoRef<HTMLHRElement>): JSX.Element => <hr {..._mergeProps({
  css: _staticStyles,
  className: className
}, props)} />;
export default Divider;